<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white">Dashboard</router-link>
      <router-link to="/school/examination-and-assessment" class="text-white">
        <i class="fa fa-ellipsis-v px-2"></i>Examination and Assessment Management
      </router-link>
      <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Other Exam Setup</span>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <modal :show.sync="modals.questionModal" modal-classes="modal-dialog-centered modal-lg">
            <div class="card bg-secondary border-0 mb-0">
              <div class="card-body">
                <PageSpinner :onloader="onloader" />
                <div class="form-horizontal">
                  <div class="form-group">
                    <label>Question Title</label>
                    <vue-editor id="ExamTitleVal" v-model="ExamTitleVal"></vue-editor>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Exam Period (In Seconds)</label>
                        <input type="number" min="0" v-model="ExamPeriodVal" class="form-control" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>No. of Question to Display</label>
                        <input type="number" min="0" v-model="NoofQuestiontoDisplayVal" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Is Admission Question</label>
                        <input type="checkbox" v-model="IsAdmissionVal" class="form-control-sm" />
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Is Continuous Assessment Question</label>
                        <input type="checkbox" v-model="IsContinuousAssessmentVal" class="form-control-sm" />
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Is Promotion Question</label>
                        <input type="checkbox" v-model="IsPromotionVal" class=" form-control-sm" />
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Is Preparation Question</label>
                        <input type="checkbox" v-model="IsPreparationVal" class="form-control-sm" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Caution Note</label>
                    <vue-editor id="CautionNoteVal" v-model="CautionNoteVal"></vue-editor>
                  </div>
                </div>
              </div>
            </div>
            <template slot="footer">
              <base-button type="default" @click="modals.questionModal = false">Cancel</base-button>
              <base-button type="success" @click.prevent="submitFormData">Submit</base-button>
            </template>
          </modal>

          <div class="cbt-filters d-flex flex-column flex-md-row align-items-stretch align-items-md-center">
            <button type="button" @click.prevent="openNew" class="btn btn-default">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

          <div class="table-responsive mt-2 cbt-table-wrap">
            <table class="table table-hover table-borderless table-striped cbt-table">
              <thead>
                <tr>
                  <th>Pass Code</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in CbtHeaderItems" :key="item.schoolExamHeaderId">
                  <td class="align-middle" data-label="Pass Code">{{ item.passCode }}</td>
                  <td class="align-middle cbt-details-cell" data-label="Details">
                    <div class="question-details" v-html="item.examTitle"></div>                   
                    <table class="table table-sm table-bordered cbt-meta-table">
                      <thead>
                        <tr>
                          <th>No of Question to Display</th>
                          <th>Is Admission</th>
                          <th>Is Continuous Assessment</th>
                          <th>Is Preparation</th>
                          <th>Is Promotion</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Questions">{{ item.noofQuestiontoDisplay }}</td>
                          <td data-label="Is Admission">{{ item.isAdmission }}</td>
                          <td data-label="Is Continuous Assessment">{{ item.isContinuousAssessment }}</td>
                          <td data-label="Is Preparation">{{ item.isPreparation }}</td>
                          <td data-label="Is Promotion">{{ item.isPromotion }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="align-middle actions-cell" data-label="Actions">
                      <span class="actions-label">Actions</span>
                      <button class="btn btn-outline-primary btn-sm" title="Edit"
                        @click.prevent="edititem(item)"><i class="fa fa-edit"></i>Edit</button>
                      <button class="btn btn-outline-primary btn-sm" type="button"
                        @click.stop.prevent="openquestion(item.schoolExamHeaderId)"><i
                          class="fa fa-eye"></i><span>Questions</span></button>
                      <!-- <button class="btn btn-outline-primary btn-sm" type="button"
                        @click.stop.prevent="openitemanswer(item.schoolExamHeaderId)"><i
                          class="fa fa-users"></i><span>View Answered Questions</span></button> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from '@/components/PageSpinner'
import ValidateAccessToken from '@/mixins/ValidateAccessToken.mixins'
import Alert from '@/mixins/Alert.mixins'
import katex from 'katex'
import 'katex/dist/katex.min.css'
window.katex = katex

export default {
  name: 'questionheader',
  mixins: [ValidateAccessToken, Alert],
  components: { PageSpinner, VueEditor },
  data() {
    return {
      accessDetails: null,
      SchoolExamHeaderIdVal: 0,
      ExamTitleVal: '',
      ExamPeriodVal: 50,
      CautionNoteVal: '',
      NoofQuestiontoDisplayVal: 10,
      IsAdmissionVal: false,
      IsContinuousAssessmentVal: false,
      IsPromotionVal: false,
      IsPreparationVal: false,
      CbtHeaderItems: null,
      isModified: false,
      onloader: 'none',
      modals: {
        questionModal: false
      },
      openMenuId: null
    }
  },
  methods: {
    openNew() {
      this.SchoolExamHeaderIdVal = 0
      this.ExamTitleVal = ''
      this.ExamPeriodVal = 50
      this.CautionNoteVal = ''
      this.NoofQuestiontoDisplayVal = 10
      this.IsAdmissionVal = false
      this.IsContinuousAssessmentVal = false
      this.IsPromotionVal = false
      this.IsPreparationVal = false
      this.isModified = false
      this.modals.questionModal = true
    },
    openquestion(id) {
      localStorage.setItem('SchcbtheaderId', id);
      this.$router.push('/school/examination-and-assessment/cbt-question-others')
    },
    openitemanswer(id) {
      localStorage.setItem('SchcbtheaderId', id);
      this.$router.push('/school/examination-and-assessment/cbt-answers')
    },   
    toggleMenu(id) { this.openMenuId = this.openMenuId === id ? null : id },
    closeMenu() { this.openMenuId = null },
    edititem(item) {     
      this.SchoolExamHeaderIdVal = item.schoolExamHeaderId
      this.ExamPeriodVal = item.examPeriod || ''
      this.CautionNoteVal = item.cautionNote || ''
      this.NoofQuestiontoDisplayVal = item.noofQuestiontoDisplay || ''
      this.IsAdmissionVal = item.isAdmission || false
      this.IsContinuousAssessmentVal = item.isContinuousAssessment || false
      this.IsPromotionVal = item.isPromotion || false
      this.IsPreparationVal = item.isPreparation || false
      this.ExamTitleVal = item.examTitle || ''
      this.isModified = true
      this.modals.questionModal = true
    },
    submitFormData() {
      if (!this.ExamTitleVal || !this.ExamPeriodVal || !this.CautionNoteVal) return this.ShowAlertWarning('Please complete the required fields', '')
      const examPeriod = parseInt(this.ExamPeriodVal, 10)
      const questionCount = parseInt(this.NoofQuestiontoDisplayVal, 10)
      if (isNaN(examPeriod) || examPeriod < 0 || isNaN(questionCount) || questionCount <= 0) return this.ShowAlertWarning('Enter valid exam period and question count', '')
      const data = {
        schoolExamHeaderId: this.SchoolExamHeaderIdVal,
        examTitle: this.ExamTitleVal,
        cautionNote: this.CautionNoteVal,
        examPeriod: examPeriod,
        noofQuestiontoDisplay: questionCount,
        isAdmission: this.IsAdmissionVal,
        isContinuousAssessment: this.IsContinuousAssessmentVal,
        isPromotion: this.IsPromotionVal,
        isPreparation: this.IsPreparationVal
      }
      if (this.isModified) data.schoolExamHeaderId = this.SchoolExamHeaderIdVal
      this.onloader = 'flex'
      this.$store.dispatch(this.isModified ? 'SchoolQuestion/UpdateSchoolQuestionHeaderOthers' : 'SchoolQuestion/CreateSchoolQuestionHeaderOthers', data).then(resp => {
        this.onloader = 'none'
        if (resp.responseCode === '00') {
          this.modals.questionModal = false;
          this.GetSchoolQuestionHeader();
          this.ShowAlertSuccess(resp.responseMessage, '')
        } else
          this.ShowAlertError(resp.responseMessage, '')
      }).catch(err => {
        this.onloader = 'none';
        this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '')
      })
    },  
    runQuestionAction(action, id) {
      this.onloader = 'flex'
      this.$store.dispatch(action, { QuestionHeaderId: id }).then(resp => { 
        this.onloader = 'none'; 
        if (resp.responseCode === '00') { 
          this.GetSchoolQuestionHeader(); 
          this.ShowAlertSuccess(resp.data, '') 
        } else this.ShowAlertError(resp.responseMessage, '') 
      }).catch(err => { 
        this.onloader = 'none'; 
        this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '') 
      })
    },   
    GetSchoolQuestionHeader() {
      this.onloader = 'flex'
      this.$store.dispatch('SchoolQuestion/GetSchoolExamHeaderOthers')
        .then(resp => {
          this.CbtHeaderItems = resp.responseCode === '00' ? resp.data : []; this.onloader = 'none'
        }).catch(err => {
          this.onloader = 'none';
          this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '')
        })
    },

  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user']
    if (this.accessDetails && this.accessDetails.isSchoolStaff === false) {
      this.$store.dispatch('auth/Logout');
      this.$router.push('/login'); return
    }
    this.GetSchoolQuestionHeader()
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy() { document.removeEventListener('click', this.closeMenu) }
}
</script>

<style scoped>
.cbt-filters {
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.cbt-filters .form-control {
  flex: 1 1 0;
  min-width: 0;
}

.table-responsive {
  width: 100%;
  overflow-x: auto !important;
  overflow-y: visible;
}

.cbt-table-wrap {
  border: 1px solid #e9ecef;
  border-radius: 0.65rem;
  background: #fff;
  box-shadow: 0 0.35rem 1rem rgba(50, 50, 93, 0.06);
}

.cbt-table {
  min-width: 920px;
  margin-bottom: 0;
}

.cbt-table>thead {
  background: #f8fafc;
}

.cbt-table>thead th {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e9ecef;
  color: #525f7f;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cbt-table>tbody>tr {
  transition: background-color 0.18s ease;
}

.cbt-table>tbody>tr:hover {
  background: #fbfcfe;
}

.cbt-table>tbody>tr>td {
  padding: 1rem;
  border-top: 1px solid #edf0f5;
  color: #344767;
}

.cbt-table>tbody>tr>td:first-child {
  width: 13rem;
  color: #172b4d;
  font-weight: 700;
  white-space: nowrap;
}

.question-details {
  margin-bottom: 0.85rem;
  color: #344767;
  line-height: 1.55;
}

.question-details :last-child {
  margin-bottom: 0;
}

.cbt-meta-table {
  min-width: 0;
  margin-bottom: 1rem;
  background: #fbfcfe;
}

.cbt-meta-table th {
  color: #8898aa;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
}

.cbt-meta-table td,
.cbt-meta-table th {
  padding: 0.55rem 0.65rem;
  vertical-align: middle;
}

.table-responsive td {
  overflow-wrap: anywhere;
}

.table-responsive td p {
  margin-bottom: 0;
}

.actions-cell {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));
  gap: 0.45rem;
  min-width: 190px;
}

.actions-label {
  grid-column: 1 / -1;
  color: #8898aa;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.actions-cell .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 2.15rem;
  margin: 0;
  white-space: normal;
  text-align: center;
}

.actions-cell .btn i {
  flex: 0 0 auto;
}

.exam-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.3rem;
  border: 1px solid #e9ecef;
  border-radius: 0.75rem;
  background: #f8f9fa;
  box-shadow: 0 2px 8px rgba(50, 50, 93, 0.08);
}

.exam-actions>.btn,
.action-menu-button {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  padding: 0;
}

.exam-actions .btn:hover,
.exam-actions .btn:focus,
.action-menu-button[aria-expanded="true"] {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(50, 50, 93, 0.16);
}

.action-toggle-wrap {
  position: relative;
  display: inline-flex;
}

.action-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 235px;
  z-index: 1100;
  padding: 0.4rem;
  overflow: hidden;
  border: 1px solid #e9ecef;
  border-radius: 0.65rem;
  background: #fff;
  box-shadow: 0 12px 30px rgba(50, 50, 93, 0.18), 0 3px 8px rgba(0, 0, 0, 0.08);
}

.action-dropdown-title {
  padding: 0.45rem 0.65rem 0.35rem;
  color: #8898aa;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.action-dropdown button {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.65rem;
  padding: 0.6rem 0.65rem;
  border: 0;
  border-radius: 0.45rem;
  background: transparent;
  color: #344767;
  font-size: 0.82rem;
  text-align: left;
}

.action-dropdown button i {
  width: 1rem;
  color: #5e72e4;
  text-align: center;
}

.action-dropdown button:hover,
.action-dropdown button:focus {
  outline: 0;
  background: #f6f9fc;
  color: #172b4d;
}

@media (max-width: 576px) {

  .cbt-filters .form-control,
  .cbt-filters .btn {
    width: 100%;
    margin: 0;
  }

  .cbt-table-wrap {
    overflow: visible !important;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .cbt-table-wrap>.cbt-table>thead {
    display: none;
  }

  .cbt-table-wrap>.cbt-table,
  .cbt-table-wrap>.cbt-table>tbody,
  .cbt-table-wrap>.cbt-table>tbody>tr,
  .cbt-table-wrap>.cbt-table>tbody>tr>td {
    display: block;
    width: 100%;
    min-height: 2rem;
  }

  .cbt-table-wrap>.cbt-table {
    min-width: 0;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr {
    margin-bottom: 0.75rem;
    border: 1px solid #e9ecef;
    border-radius: 0.65rem;
    background: #fff;
    box-shadow: 0 0.35rem 1rem rgba(50, 50, 93, 0.06);
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td {
    padding: 0.8rem 0.9rem;
    border: 0;
    border-bottom: 1px solid #f1f3f5;
    text-align: left;
    position: relative;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td::before {
    content: attr(data-label) ": ";
    display: block;
    margin-bottom: 0.25rem;
    font-weight: 600;
    color: #495057;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td:first-child {
    width: 100%;
    white-space: normal;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td:last-child {
    border-bottom: 0;
  }

  .cbt-meta-table {
    display: block;
    border: 1px solid #e9ecef;
    border-radius: 0.45rem;
    overflow: hidden;
  }

  .cbt-meta-table thead {
    display: none;
  }

  .cbt-meta-table tbody,
  .cbt-meta-table tbody tr,
  .cbt-meta-table tbody td {
    display: block;
    width: 100%;
  }

  .cbt-meta-table tbody tr {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .cbt-meta-table tbody td {
    padding: 0.55rem 0.45rem;
    border: 0;
    border-right: 1px solid #e9ecef;
    text-align: center;
    font-size: 0.78rem;
  }

  .cbt-meta-table tbody td::before {
    content: attr(data-label);
    display: block;
    margin-bottom: 0.15rem;
    color: #8898aa;
    font-size: 0.62rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .cbt-meta-table tbody td:last-child {
    border-right: 0;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td.actions-cell {
    text-align: left;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td.actions-cell::before {
    display: block;
    float: none;
    margin-bottom: 0.25rem;
  }

  .actions-cell .btn {
    min-width: 0;
  }

  .exam-actions {
    width: 100%;
    justify-content: flex-start;
    padding: 0.4rem;
  }

  .action-dropdown {
    width: min(235px, calc(100vw - 3rem));
  }
}

@media (max-width: 380px) {
  .actions-cell {
    grid-template-columns: 1fr;
  }
}
</style>
